exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".privacy-content[data-v-0dbaaf49]{max-height:600px;padding-right:15px;overflow-y:auto}", ""]);

// exports
